import React from 'react';
import { observer } from 'mobx-react-lite';
import { fg } from '@atlaskit/platform-feature-flags';
import { toTextQuestionAnswer } from '../../stores/QuestionStore';
import { DisplayMode } from '../RenderForm';
import { EditNumber } from './edit/EditNumber';
import { ViewNumber } from './view/ViewNumber';
export const Number = observer(({
  id,
  questionStore,
  displayMode
}) => {
  const showEditComponent = displayMode === DisplayMode.Edit;
  if (showEditComponent) {
    var _questionStore$formQu, _questionStore$formQu2;
    return /*#__PURE__*/React.createElement(EditNumber, {
      id: id,
      value: toTextQuestionAnswer(questionStore.currentAnswer),
      isInvalid: !!questionStore.validationErrors,
      isRequired: fg('proforma_a11y_mandatory_fields') ? ((_questionStore$formQu = questionStore.formQuestion) === null || _questionStore$formQu === void 0 ? void 0 : (_questionStore$formQu2 = _questionStore$formQu.validation) === null || _questionStore$formQu2 === void 0 ? void 0 : _questionStore$formQu2.rq) || false : undefined,
      onChange: event => {
        const value = event.target.value.trim().replace(/[^\d.\-,]/g, '');
        questionStore.setAnswer(value);
      }
    });
  }
  return /*#__PURE__*/React.createElement(ViewNumber, {
    id: id,
    value: toTextQuestionAnswer(questionStore.currentAnswer),
    displayMode: displayMode
  });
});